export enum ResultsStatus {
    Ok,
    Warning,
    Error,
    Unknown
}